<template>
    <Navbar></Navbar>
    <div class="page-box">
        <div class="img-box page-banner">
            <img src="/assets/manufacture/transmission/taizhou/tz.jpg" alt=""></img>
            <div class="title-box">
                <div class="manufacture-t1">
                    Taizhou Driveline Plant
                </div>
                <div class="manufacture-t2">
                    Located in Taizhou City, Jiangsu Province, the project was completed in December 2020, covering an area of 12,000 square meters.<br />
                    It has the production capacity for the assembly of hydraulic modules and dual-clutch modules (500,000 units each), as well as in-house manufacturing of dual-clutch module housings (250,000 units).
                </div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                DCM/HCM Assembly Line
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    
                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                EOL Test
                            </div>
                            <div class="destils">
                                ① Uses dedicated test benches to conduct 100% full-function and full-performance testing, realizing full lifecycle traceability of product quality.<br />
                                ② The test bench automation rate reaches 100%, and equipment availability is stably above 95%, ensuring efficient and continuous test operation.<br />
                                ③ The program is equipped with an automatic interlock error-proofing mechanism, which fundamentally avoids risks to personnel, products and equipment.
                            </div>
                        </div>
                        <div class="img-box">
                            <img src="/assets/manufacture/transmission/taizhou/tz1-1.jpg" alt="">
                        </div>
                    </div>

                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>


    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';

// 存储所有swiper实例，方便销毁
const swiperInstances = ref([]);

// 初始化所有轮播的核心函数
const initAllSwipers = async () => {
    await nextTick();

    const swiperElements = document.querySelectorAll('.swiper-item');

    swiperElements.forEach(el => {
        if (el) {
            const swiper = new Swiper(el, {
                speed: 1300,
                pagination: {
                    el: el.querySelector(".swiper-pagination"), // 绑定当前容器内的分页器
                    clickable: true,
                },
                direction: "horizontal",
                slidesPerView: 1,
                // spaceBetween: 20,
                simulateTouch: true,
                effect: 'fade',
                breakpoints: {
                    768: {},
                    1024: {}
                },
                // navigation: {
                //     nextEl: el.querySelector(".btn-r"),
                //     prevEl: el.querySelector(".btn-l"),
                //     disabledClass: 'swiper-button-disabled',
                // },
                on: {
                    // init: function () {
                    //     console.log('轮播初始化完成');
                    // },
                    // slideChangeTransitionStart(swiper) {
                    //     let swiperIndex = swiper.realIndex;
                    //     console.log('当前轮播索引：', swiperIndex);
                    // },
                },
            });
            swiperInstances.value.push(swiper); // 保存实例
        }
    });
};

// 页面挂载时初始化轮播
onMounted(() => {
    initAllSwipers();
});

// 页面卸载时销毁轮播实例（防止内存泄漏）
onUnmounted(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: 'Taizhou Driveline Plant - FINEST Website',
    keywords: 'FINEST,Engine,Transmission,Electronics',
    description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
    outputPath: 'en/manufacture/tr/taizhou.html'
};

import { createApp } from 'vue';
import App from './taizhou.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/manufacture-detail.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./taizhou.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss"></style>
